
/*
  This component will display steps in configurator
 */

import React, {useEffect, useState} from 'react'
import Select from "../common_elements/Select";
import Radio from "../common_elements/Radio";
import ExceptionMessage from "../common_elements/ExceptionMessage"
import { useDispatch, useSelector} from "react-redux";
import {productSelectionChanged} from "../../store/product/productSelectionsSlice";
import {shouldUpdateModulesSet} from "../../store/configuratorStateSlice";
import {updateElementSelection} from "../../store/product/productElementsSlice";

const ElementOptionalAttributeStep = (props) => {
    const [showException, setShowException] = useState(false);
    const [messages, setMessages] = useState([]);
    const [exceptionLeft, setExceptionLeft] = useState(0);
    const [hideFields, setHideFields] = useState(false);
    const dispatch = useDispatch();
    const disabledFields = useSelector(state => state.disabledFieldsReducer.disabledElementFields);

    const elementsShowingHidden = useSelector(state => state.configuratorStateReducer.elementsShowingHidden);

    useEffect(()=> {
        setShowException(false)
        setMessages([])
    }, [])

    useEffect(() => {
        setHideFields(props.hasHiddenFields && !elementsShowingHidden.includes(props.elementKey))
    }, [elementsShowingHidden]);

    const handleAttribute = (option, value) => {

        // only update modules when length changes
        // if(option.internal_name == 'row_layout') {
        //     dispatch(shouldUpdateModulesSet(true))
        // } else {
        //     dispatch(shouldUpdateModulesSet(false))
        // }
        dispatch(updateElementSelection(props.elementKey, option, value));

    }

    const handleDisabledClick = (option, e) => {
        setShowException(true)
        const mouseX = e.pageX;
        const matchingField = disabledFields[props.elementKey].find(obj => obj.id == option.id);
        const message = matchingField.messages;
        setExceptionLeft(mouseX);
        setMessages(message)
    }

    const getFields = () => {
        let fields = [];
        let selected = props.currentValues || [];
        props.options.forEach(function(el){
            // find current selection for this attribute or option
            let current = selected.find(x=> x.id == el.id);
            // get the value of the selection
            let currentVal = current != null ? current.selection : ''
            const disabledSelections = getDisabledSelections(el);
            const inputKey = el.id + '-' + currentVal;
            if(el.values.length > 1) {
                // check if this field should be disabled based on exceptions
                const shouldDisable = shouldDisableSelect(el, disabledSelections);
                fields.push(
                    <li key={el.id}>
                        <label className={"label_select " + (shouldDisable ? 'disabled':'enabled')} title={messages.join(', ')}>
                            {el.name}
                            <Select attributes={el} currentValue={currentVal} hasEmptyField={'true'} fieldId={el.sku_order} propType={'ATTRIBUTE'}
                                    disabledSelections={disabledSelections}
                                    onClick={(e) => handleDisabledClick(el, e)} onChange={() => hideExceptionMessage()}
                                    handleAttribute={(value) => handleAttribute(el, value)}
                                    key={inputKey}
                            />
                        </label>
                    </li>

                );
            }else{
                fields.push(
                    <li key={el.id}  title={messages.join(', ')}>
                        <Radio attributes={el} currentValue={currentVal} checkType={'checkbox'} fieldId={el.sku_order} propType={'ATTRIBUTE'}
                               disabledSelections={disabledSelections}
                               handleAttribute={(value) => handleAttribute(el, value)}
                               onClick={(e) => handleDisabledClick(el, e)}
                               key={inputKey}
                        />
                    </li>
                );
            }
        }, this);

        return fields;
    }

    const shouldDisableSelect = (attribute, disabled) => {
        const selections = attribute.values.split(",");
        return selections.length == disabled.length;
    }

    const getDisabledSelections = (optionalAttribute) => {
        if(disabledFields == null || disabledFields[props.elementKey] == null){
            return [];
        }
        const matchingField = disabledFields[props.elementKey].find(obj => obj.id == optionalAttribute.id);
        return matchingField ? matchingField.disabledSelections : [];
    };

    const exceptionMessage = () => {
        if(!showException || messages.length == 0) {
            return
        }

        return <ExceptionMessage message={messages} posLeft={exceptionLeft}/>
    }

    const hideExceptionMessage = () => {
        setMessages([])
        setShowException(false)
    }
    if(hideFields) {
        return <></>
    }
    return (
        <div style={{position: 'relative'}}>
            <div className="configurator-step" onMouseLeave={() => hideExceptionMessage()}>
                <div className="row flex-row">
                    <div className="title small-12 medium-2 columns">
                        <h3 style={{paddingTop: '3px'}}>Options</h3>
                    </div>
                    <div className="selection small-12 medium-10 columns">
                        <fieldset style={{width: '100%'}}>
                            <ul className="optional-attribute-list">
                                {getFields()}
                            </ul>
                        </fieldset>
                    </div>
                </div>
            </div>
            {exceptionMessage()}
        </div>
    )
}



export default ElementOptionalAttributeStep;


